import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  wholesalerProductDeleteRequest,
  wholesalerProductResetState,
  wholesalerProductViewByWholesalerIdRequest,
} from "../../../redux/wholesalerProduct/WholesalerProductAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomDataGrid from "../../constant/commondatagrid";
import DeleteDialog from "../../constant/commonDeleteDialogBox";
import Pagination from "../../constant/CommonPagenation";
import { filterStyles, styles } from "../../components/LoginStyles";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import { CircleLoader } from "react-spinners";

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/wholesaler/product/edit/${user?.id}`);
    handleClose();
  };

  const handleView = () => {
    navigate(`/wholesaler/product/view/${user?.id}`);
    handleClose();
  };

  const handleDelete = () => {
    onDelete(user?.id);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleView} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const columns = (handleDeleteRow) => [
  {
    field: "type_of_alcohol_id",
    headerName: "Type Of Alcohol",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.ProductAlcoholType || "Unknown Type",
  },
  {
    field: "brand_id",
    headerName: "Brand Name",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.BrandName || "Unknown Brand",
  },
  {
    field: "ProductName",
    headerName: "Sub Brand Name",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.ProductName || "N/A",
  },
  {
    field: "type_of_quantity_id",
    headerName: "Quantity (Unit)",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.TypeOfQuantity || "N/A",
  },
  {
    field: "alcohol_percentage",
    headerName: "Alcohol Percentage",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.AlcoholPercentage || "N/A",
  },
  {
    field: "price",
    headerName: "Price",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.Price || "0",
  },
  {
    field: "quantity",
    headerName: "Stock",
    width: getColumnWidth("column"),
    renderCell: (params) => params?.row?.Quantity || "0",
  },
  {
    field: "status",
    headerName: "Status",
    renderCell: (params) =>
      params?.row?.Status === 1 ? (
        <ActiveValue>Active</ActiveValue>
      ) : (
        <InactiveValue>Inactive</InactiveValue>
      ),
    width: getColumnWidth("column"),
  },
  {
    field: "actions",
    headerName: "Actions",
    width: getColumnWidth("column"),
    renderCell: (params) => (
      <ActionMenu user={params?.row} onDelete={handleDeleteRow} />
    ),
  },
];

const ProductList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchTerm, setSearchTerm] = useState("");

  const id = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  const dispatch = useDispatch();
  const productViewAllState = useSelector(
    (state) =>
      state?.wholesalerProduct?.viewWholesalerProductByWholesalerId || {}
  );

  const productList = productViewAllState?.products || [];

  const totalRecords = productViewAllState?.totalRecords || 0;
  const productPageSize = productViewAllState?.pagesize || 10;

  const wholesalerProductDeleteState = useSelector(
    (state) => state?.wholesalerProduct?.deleteWholesalerProduct || {}
  );

  const preprocessData = (data) => {
    if (!data) return [];
    if (!Array.isArray(data)) data = [data];

    const uniqueIds = new Set();
    return data
      .map((item) => {
        if (uniqueIds.has(item?.id)) return null;
        uniqueIds.add(item?.id);

        const typeOfQuantity =
          item?.ProductQuantity?.type_of_quantity || "Unknown";
        const measurements = item?.ProductQuantity?.measurements || "";
        const capacity = `${typeOfQuantity} ${measurements}`.trim();

        return {
          id: item?.id,
          ProductId: item?.product_id,
          ProductName: item?.Product?.product_name,
          BrandName: item?.Brand?.brand_name || "",
          ProductAlcoholType: item?.ProductAlcoholType?.alcohol_type || "",
          TypeOfQuantity: capacity,
          Measurements: item?.ProductQuantity?.measurements || "",
          Price: item?.price || "",
          Quantity: item?.quantity || "",
          Status: item?.status || "",
          AlcoholPercentage: item?.alcohol_percentage || "",
          CreatedAt: item?.created_at || "",
          UpdatedAt: item?.updated_dt || "",
        };
      })
      .filter((item) => item !== null);
  };

  // useEffect(() => {
  //   if (id) {
  //     dispatch(wholesalerProductViewByWholesalerIdRequest(id, currentPage));
  //   }
  // }, [dispatch, id, currentPage]);

  // useEffect(() => {
  //   if (productViewAllState?.success) {
  //     const processedData = preprocessData(productList);
  //     setRows(processedData);
  //   } else {
  //     setRows(emptyList);
  //   }
  // }, [productList, productViewAllState]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    if (!id) return;

    const debounceTimer = setTimeout(() => {
      const payload = {
        wholesalerProductId: id,
        pageNo: currentPage,
        search_key: searchTerm.trim(),
      };
      dispatch(
        wholesalerProductViewByWholesalerIdRequest(id, currentPage, searchTerm)
      );
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [id, currentPage, searchTerm, dispatch]);

  useEffect(() => {
    if (productViewAllState?.success) {
      const processedData = preprocessData(productList);
      setRows(processedData);
    } else {
      setRows(emptyList);
    }
  }, [productList, productViewAllState]);

  useEffect(() => {
    if (wholesalerProductDeleteState?.success) {
      const newPage =
        rows.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

      dispatch(
        wholesalerProductViewByWholesalerIdRequest(id, newPage, searchTerm)
      );
      dispatch(wholesalerProductResetState());
      setCurrentPage(newPage);
    }
  }, [wholesalerProductDeleteState?.success]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setProductToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(wholesalerProductDeleteRequest(productToDelete));
    setProductToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleAddProduct = () => {
    navigate(APP_LINKS.ADDPRODUCT);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Product Name Asc":
        sortedRows.sort((a, b) =>
          a?.ProductName?.localeCompare(b?.ProductName)
        );
        break;
      case "Sort by Product Name Desc":
        sortedRows.sort((a, b) =>
          b?.ProductName?.localeCompare(a?.ProductName)
        );
        break;
      case "Sort by Brand Name Asc":
        sortedRows.sort((a, b) => a?.BrandName?.localeCompare(b?.BrandName));
        break;
      case "Sort by Brand Name Desc":
        sortedRows.sort((a, b) => b?.BrandName?.localeCompare(a?.BrandName));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  return (
    <>
      <Grid container spacing={2} pl={6} pr={6}>
        <Grid item xs={12} sm={5} md={7} lg={8} xl={9}>
          <Box className="headingTable">
            <h1>Product Management</h1>
            <p>Here is your general products list data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={7} md={5} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              onClick={handleAddProduct}
              sx={styles.addButtonColor}
            >
              Add New
            </Button>

            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Asc")}
          >
            Product Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Desc")}
          >
            Product Name Z-A
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Brand Name Asc")}
          >
            Brand Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Brand Name Desc")}
          >
            Brand Name Z-A
          </MenuItem>
        </Menu>
        {productViewAllState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1000}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={productViewAllState?.inProgress}
                size={50}
                color="#0458d3"
              />
            </Box>
          </Box>
        )}

        {wholesalerProductDeleteState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1001}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={wholesalerProductDeleteState?.inProgress}
                size={50}
                color="#d32f2f"
              />
            </Box>
          </Box>
        )}

        <>
          <Paper>
            {/*search*/}
            <Box display="flex" justifyContent="flex-end" mb={2}>
              <input
                type="text"
                placeholder="Search by brand/sub brand or alcohol name..."
                value={searchTerm}
                onChange={handleSearchChange}
                style={{
                  padding: "8px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  width: "300px",
                }}
              />
            </Box>
            {/* {productViewAllState?.success && ( */}
            <Box>
              <CustomDataGrid
                rows={rows}
                columns={columns(handleDeleteRow)}
                pageSize={productPageSize}
                pagination={true}
                rowHeight={80}
                loading={productViewAllState?.inProgress}
              />
            </Box>
            {/* )}*/}
          </Paper>
          {productViewAllState?.success && (
            <Box mt={2}>
              <Grid>
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  pageSize={productPageSize}
                />
              </Grid>
            </Box>
          )}
        </>
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={confirmDelete}
        />
      </StyledContainer>
    </>
  );
};

export default ProductList;
